// Add your custom JS here.
(function ($) {
    //slick init
    $('.slick').slick({
        accessibility: true,
        mobileFirst: true,
        slidesToShow: 3,
        infinite: true,
        swipeToSlide: true,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    //cards on the applicant support page
    const cards = document.getElementById('cards');
    const cardparent = document.getElementById('cardparent');
    if (cards) {
        $("#cards > .card").each(function() {
            let title =  $(this).children('.wp-block-heading').text();
            let title2 = title.replace(/[^A-Z0-9]+/ig, "-").toLowerCase();
            if(title2 !="glossary") {
                this.setAttribute('href','#'+title2);
                this.setAttribute('data-bs-toggle', 'collapse');
                this.setAttribute('role', 'button');
                this.setAttribute('aria-expanded', 'false');
                this.setAttribute('aria-controls', title2);

                let hiddenDiv= $(this).next('.collapse');
                hiddenDiv.prepend('<h2>'+title+'</h2>');
                hiddenDiv.attr('id', title2);
                hiddenDiv.appendTo(cardparent);

                $(this).on( "click", function() {
                    $(cardparent).get(0).scrollIntoView({behavior: 'smooth'});
                } );
            }
        });
    }

    if (cardparent) {
        let cardparentarray = cardparent.querySelectorAll('.collapse');
        for (let i = 0; i < cardparentarray.length; i++) {
            cardparentarray[i].setAttribute('data-bs-parent', '#cardparent');
        }
    }

    //.gradient
    //${'.gradient'}//find
    let newheight = $('.wp-block-cover__inner-container').height();
    $('.wp-block-cover__background').css("height","calc("+newheight+"px + 2em)");

    //for each .group with .accordion class && has previous sibling of .header
    //let $groupID = header innertext
    //for each child with "accordion" class
    //remove "accordion" class from child
    //add data-bs-parent="#parentID" to child
    
    if($(".wp-block-group.accordion").length){
        let groupID;
        $(".wp-block-group.accordion").each(function() {
            groupID = $( this ).prev().text().toLowerCase().replace(/[^A-Z0-9]+/ig, "");
            $( this ).attr("id", groupID);
            $( this ).children().removeClass('accordion');
            $( this ).find(".accordion-collapse").each(function() {
              $(this).attr('data-bs-parent', "#"+groupID);
            });
        })
    }

    //gravity forms scroll
	const thanks = document.getElementById('thanks');
	if (thanks) {
        thanks.scrollIntoView({ behavior: "instant" });
    }

    const target = window.location.hash;
    // only try to scroll to offset if target has been set in location hash
    if (target != '' && $('a[href*="'+target+'"]') ) {
        $('a[href*="'+target+'"]')[0].click();
    }

})(jQuery);